<template>
  <div id="SectionEcovadisTargetRating">
    <UIContainer class="SectionEcovadisTargetRating__container">
      <template #left>
        <img
          class="SectionEcovadisTargetRating__image"
          src="./assets/ecovadisTargetRating/bg.avif"
          alt="Skip the confusion and achieve your target rating"
        />
      </template>

      <template #right>
        <div class="SectionEcovadisTargetRating__content">
          <SectionTitle titleSize="sm">
            <template #title>
              Skip the confusion and achieve your target rating
            </template>

            <template #description>
              You’ll get a complete evidence pack, policy set tailored to your
              operations, KPI workbook linked to Sustainalyse data, procedure
              templates, and a submission checklist. We don’t just upload files
              - we wire the process so you can maintain and scale it.
            </template>
          </SectionTitle>

          <div class="SectionEcovadisTargetRating__features">
            <div
              class="SectionEcovadisTargetRating__feature"
              v-for="feature in features"
              :key="feature"
            >
              <UIIcon
                class="SectionEcovadisTargetRating__feature-icon"
                name="checkCircle"
              />
              <span>{{ feature }}</span>
            </div>
          </div>

          <div class="SectionEcovadisTargetRating__cta">
            <UIButton size="xl" :to="{ name: 'Contact' }">
              Book a call
            </UIButton>
          </div>
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'

const features = [
  '90-day certification roadmap',
  'Gap analysis agains EcoVadis methodology',
  'Document preparation and evidence compilation',
  'Ongoing support packages for annual assessments',
]
</script>

<style lang="scss" scoped>
#SectionEcovadisTargetRating {
  position: relative;

  .SectionEcovadisTargetRating__container {
    // padding-top: 0;
    // padding-bottom: 0;
  }

  .SectionEcovadisTargetRating__image {
    display: none;
    position: absolute;
    max-height: 32rem;

    @include md {
      display: block;
      right: 0;
    }
  }

  .SectionEcovadisTargetRating__content {
    padding: 1rem 0;
    @include md {
      margin-left: 6rem;
    }
  }

  .SectionEcovadisTargetRating__title {
    @include font-size-20px();
    font-weight: 600;
    line-height: 1.2;
    color: $color-ui-gray-cool-900;
    margin-bottom: 1rem;

    @include md {
      @include font-size-24px();
    }
  }

  .SectionEcovadisTargetRating__features {
    display: grid;
    gap: 1.25rem;
    padding-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .SectionEcovadisTargetRating__feature {
    @include font-size-18px();
    display: flex;
    align-items: center;
    color: $color-ui-gray-cool-600;
    gap: 0.75rem;
  }

  .SectionEcovadisTargetRating__feature-icon {
    --size: 1.75rem;
  }

  .SectionEcovadisTargetRating__cta {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>
